const PowerUserIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="powerGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#FFA500" />
      </radialGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.5)" />
      </filter>
    </defs>
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#powerGradient)"
      stroke="#000"
      stroke-width="3"
      filter="url(#dropShadow)"
    />
    <defs>
      <radialGradient id="boltGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#FFA500" />
        <stop offset="100%" stop-color="#FF4500" />
      </radialGradient>
    </defs>
    <polygon
      points="45,30 60,30 50,50 65,50 40,75 50,55 35,55"
      fill="url(#boltGradient)"
      stroke="#000"
      stroke-width="2"
      filter="url(#dropShadow)"
    />
    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.2)" />
  </svg>
)

const FirstSteps = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="firstStepsGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#1E90FF" />
        <stop offset="100%" stop-color="#00BFFF" />
      </radialGradient>
      <radialGradient id="stepsGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#FFA500" />
      </radialGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.5)" />
      </filter>
    </defs>
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#firstStepsGradient)"
      stroke="#000"
      stroke-width="3"
      filter="url(#dropShadow)"
    />
    <polygon
      points="50,25 65,50 50,75 35,50"
      fill="url(#stepsGradient)"
      stroke="#000"
      stroke-width="2"
      filter="url(#dropShadow)"
    />
    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.2)" />
  </svg>
)


const AIExplorer = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="aiExplorerGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#1E90FF" />
        <stop offset="100%" stop-color="#0000CD" />
      </radialGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.5)" />
      </filter>
    </defs>
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#aiExplorerGradient)"
      stroke="#000"
      stroke-width="3"
      filter="url(#dropShadow)"
    />

    <path d="M30,80 Q50,60 70,80" fill="#8B4513" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />

    <rect x="44" y="50" width="12" height="30" fill="#FFFFFF" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <rect x="42" y="45" width="16" height="8" fill="#FF0000" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <rect x="47" y="35" width="6" height="10" fill="#FFD700" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <rect x="46" y="30" width="8" height="5" fill="#FFFFFF" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />

    <polygon
      points="40,30 50,5 60,30"
      fill="rgba(255, 255, 0, 0.5)"
      stroke="none"
      filter="url(#dropShadow)"
      transform="rotate(90 50 20) translate(15, 20)"
    />

    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.2)" />
  </svg>
)

const AIThoughtLeader = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="thoughtLeaderGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#8A2BE2" />
        <stop offset="100%" stop-color="#4B0082" />
      </radialGradient>
      <radialGradient id="brainGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#FFA500" />
      </radialGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.5)" />
      </filter>
    </defs>
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#thoughtLeaderGradient)"
      stroke="#000"
      stroke-width="3"
      filter="url(#dropShadow)"
    />
    <path
      d="M50,30 C40,25 30,35 30,50 C30,65 40,75 50,70 C60,75 70,65 70,50 C70,35 60,25 50,30 Z"
      fill="url(#brainGradient)"
      stroke="#000"
      stroke-width="2"
      filter="url(#dropShadow)"
    />
    <line x1="40" y1="35" x2="45" y2="45" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="45" y1="45" x2="35" y2="50" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="35" y1="50" x2="45" y2="55" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="45" y1="55" x2="40" y2="65" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="60" y1="35" x2="55" y2="45" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="55" y1="45" x2="65" y2="50" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="65" y1="50" x2="55" y2="55" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="55" y1="55" x2="60" y2="65" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.2)" />
  </svg>
)


const AutomationArchitect = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="automationArchitectGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#228B22" />
        <stop offset="100%" stop-color="#006400" />
      </radialGradient>
      <radialGradient id="gearGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#FFD700" />
        <stop offset="100%" stop-color="#FFA500" />
      </radialGradient>
      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.5)" />
      </filter>
    </defs>
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#automationArchitectGradient)"
      stroke="#000"
      stroke-width="3"
      filter="url(#dropShadow)"
    />
    <path d="M50,35 L55,40 L65,38 L68,42 L63,50 L68,58 L65,62 L55,60 L50,65 L45,60 L35,62 L32,58 L37,50 L32,42 L35,38 L45,40 Z"
      fill="url(#gearGradient)" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="30" y1="70" x2="50" y2="50" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <line x1="50" y1="50" x2="70" y2="30" stroke="#000" stroke-width="2" filter="url(#dropShadow)" />
    <circle cx="30" cy="70" r="3" fill="#FFD700" stroke="#000" stroke-width="1" filter="url(#dropShadow)" />
    <circle cx="70" cy="30" r="3" fill="#FFD700" stroke="#000" stroke-width="1" filter="url(#dropShadow)" />
    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.2)" />
  </svg>
)

const BetaTesterBadge = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="betaBadgeGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#4B0082" />
        <stop offset="100%" stopColor="#2E0854" />
      </radialGradient>

      <radialGradient id="bubbleGradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="100%" stopColor="#FFA500" />
      </radialGradient>

      <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="rgba(0,0,0,0.5)" />
      </filter>
    </defs>

    {/* Hex Badge Background */}
    <polygon
      points="50,5 90,25 90,75 50,95 10,75 10,25"
      fill="url(#betaBadgeGradient)"
      stroke="#000"
      strokeWidth="3"
      filter="url(#dropShadow)"
    />

    {/* Chat Bubble with Checkmark */}
    <path
      d="M35 35H65C67 35 68 36.5 68 38.5V60.5C68 62.5 67 64 65 64H52L45 70V64H35C33 64 32 62.5 32 60.5V38.5C32 36.5 33 35 35 35Z"
      fill="url(#bubbleGradient)"
      stroke="#000"
      strokeWidth="2"
      filter="url(#dropShadow)"
    />

    {/* Checkmark */}
    <path
      d="M42 50L47 55L58 44"
      stroke="black"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* Light overlay circle */}
    <circle cx="50" cy="50" r="30" fill="rgba(255, 255, 255, 0.15)" />
  </svg>
);


export { PowerUserIcon, FirstSteps, AIExplorer, AIThoughtLeader, AutomationArchitect, BetaTesterBadge };